export const getDialogPaperStyle = () => ({
    borderRadius: 5,
    overflow: 'hidden',
    p: 0,
    maxWidth: 500,
    width: '100%',
    boxShadow: 24,
    m: { xs: 1, sm: 3 },
    background: 'background.paper',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '90vh',
});

export const getHeaderBoxStyle = (theme) => ({
    background: theme.palette.primary.main,
    color: 'white',
    px: { xs: 1.5, sm: 3 },
    py: { xs: 1.5, sm: 2.5 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    position: 'relative',
    flexShrink: 0,
});

export const getHeaderTitleStyle = () => ({
    fontWeight: 700, 
    fontSize: '1.35rem', 
    mb: 0.5
});

export const getHeaderSubtitleStyle = () => ({
    fontSize: '0.98rem', 
    opacity: 0.85
});

export const getCloseButtonStyle = () => ({
    color: 'white', 
    ml: 2, 
    background: 'rgba(255,255,255,0.08)', 
    '&:hover': { background: 'rgba(255,255,255,0.18)' }
});

export const getContentBoxStyle = () => ({
    overflowY: 'auto', 
    flex: 1, 
    minHeight: 0
});
